export var BalanceProfileStatus;
(function (BalanceProfileStatus) {
    BalanceProfileStatus["INACTIVE"] = "INACTIVE";
    BalanceProfileStatus["ACTIVE"] = "ACTIVE";
    BalanceProfileStatus["SUSPENDED"] = "SUSPENDED";
    BalanceProfileStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    BalanceProfileStatus["DELETED"] = "DELETED";
    BalanceProfileStatus["MIGRATED"] = "MIGRATED";
    BalanceProfileStatus["UNKNOWN"] = "UNKNOWN";
})(BalanceProfileStatus || (BalanceProfileStatus = {}));
//# sourceMappingURL=balance.types.js.map